export const NotFoundPage = () => {
  return <h2>Page not found</h2>;
};
